<template>
  <v-app>
    <v-navigation-drawer
      v-if="isUserLoggedIn"
      v-model="drawer"
      app
      :permanent="$vuetify.breakpoint.lgAndUp"
      :expand-on-hover="$vuetify.breakpoint.lgAndUp"
      height="100%"
    >
      <v-list>
        <v-list-item>
          <v-list-item-icon>
            <v-img max-width=30 :src="$vuetify.theme.dark ?
            '/default_user_avatar_dark.png' : '/default_user_avatar.png'" />
          </v-list-item-icon>
          <v-list-item-title v-if="isUserLoggedIn">
            <span class="drawer-font">{{user.attributes.email}}</span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
      <v-divider v-if="camerasAllowed || mobilesAllowed || headsetsAllowed"></v-divider>
      <v-list>
        <v-list-item v-if="camerasAllowed" :to="{ name: 'Cameras', params: { type: 'camera' } }">
         <v-list-item-icon>
              <v-img max-width=30 :src="$vuetify.theme.dark ?
              '/devices_dark.png' : '/devices.png'" />
          </v-list-item-icon>
          <v-list-item-title>Cameras</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="mobilesAllowed" :to="{ name: 'Mobiles', params: { type: 'mobile' } }">
          <v-list-item-icon>
              <v-img max-width=30 src="" />
          </v-list-item-icon>
          <v-list-item-title>Mobiles</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="headsetsAllowed" :to="{ name: 'Headsets', params: { type: 'headset' } }">
          <v-list-item-icon>
              <v-img max-width=30 src="" />
          </v-list-item-icon>
          <v-list-item-title>Headsets</v-list-item-title>
        </v-list-item>
      </v-list>
      <v-divider v-if="videosAllowed || photosAllowed
      || timelapsesAllowed || uploadAllowed"></v-divider>
      <v-list>
        <v-list-item v-if="videosAllowed" @click="navigateToContentView">
          <v-list-item-icon>
            <v-img max-width=30 :src="$vuetify.theme.dark ?
            '/content_dark.png' : '/content.png'" />
          </v-list-item-icon>
          <v-list-item-title>Videos</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="photosAllowed">
          <v-list-item-icon>
            <v-img max-width=30 src="" />
          </v-list-item-icon>
          <v-list-item-title>Photos</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="timelapsesAllowed">
          <v-list-item-icon>
            <v-img max-width=30 src="" />
          </v-list-item-icon>
          <v-list-item-title>Timelapses</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="uploadAllowed" @click="uploadContentDialog = true">
          <v-list-item-icon>
            <v-img max-width=30 src="" />
          </v-list-item-icon>
          <v-list-item-title>Upload</v-list-item-title>
        </v-list-item>
      </v-list>
      <v-divider v-if="presentationsAllowed || streamsAllowed || meetingsAllowed"></v-divider>
      <v-list>
        <v-list-item v-if="presentationsAllowed">
          <v-list-item-icon>
            <v-img max-width=30 :src="$vuetify.theme.dark ?
            '/live_dark.png' : '/live.png'" />
          </v-list-item-icon>
          <v-list-item-title>Presentations</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="streamsAllowed">
          <v-list-item-icon>
            <v-img max-width=30 src="" />
          </v-list-item-icon>
          <v-list-item-title>Streams</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="meetingsAllowed">
          <v-list-item-icon>
            <v-img max-width=30 src="" />
          </v-list-item-icon>
          <v-list-item-title>Meetings</v-list-item-title>
        </v-list-item>
      </v-list>
      <v-divider v-if="videocallsAllowed"></v-divider>
      <v-list>
        <v-list-item v-if="videocallsAllowed" :to="{ name: 'Videocalls' }">
          <v-list-item-icon>
            <v-img max-width=30 :src="$vuetify.theme.dark ?
            '/logs_dark.png' : '/logs.png'" />
          </v-list-item-icon>
          <v-list-item-title>Video calls</v-list-item-title>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <v-list-item @click="toggleDarkMode">
          <v-list-item-icon>
            <v-img max-width=30 src="" />
          </v-list-item-icon>
          <v-list-item-title>
            <v-row align="center">
              <v-col>Dark theme</v-col>
              <v-col><v-switch :value="$vuetify.theme.dark"></v-switch></v-col>
            </v-row>
          </v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item @click="logout">
          <v-list-item-icon>
            <v-img max-width=30 :src="$vuetify.theme.dark ?
            '/icon_logout_dark.png' : '/icon_logout.png'" />
          </v-list-item-icon>
          <v-list-item-title>Sign out</v-list-item-title>
        </v-list-item>
        <v-list-item>
          <span class="caption">
            {{ version }}
          </span>
        </v-list-item>
      </template>
    </v-navigation-drawer>
    <v-app-bar
      v-if="isUserLoggedIn"
      :max-height="$vuetify.breakpoint.lgAndUp ? 75 : 65"
      app
    >
      <v-app-bar-nav-icon
        v-if="$vuetify.breakpoint.mdAndDown"
        @click="drawer = !drawer"
      />
      <v-container fluid>
        <v-row align="center" justify="space-between">
          <v-img
            class="ma-2"
            :max-width="$vuetify.breakpoint.lgAndUp ? 225 : 175"
            :src="$vuetify.theme.dark ? '/livesync_logo_dark.png' : '/livesync_logo.png'"
          />
          <v-card
            v-if="!!(appBarIcon1Src)"
            @click="appBarIcon1Navigate"
          >
            <v-img
              class="ma-2"
              max-width="40"
              :src=appBarIcon1Src
            />
          </v-card>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-content :class="$vuetify.theme.dark ? 'bg-color-dark' : 'bg-color'">
      <router-view />
      <v-dialog
        v-model="uploadContentDialog"
        persistent max-width="800px"
        :fullscreen="$vuetify.breakpoint.xsOnly"
      >
        <UploadContentDialog
          :dialog.sync="uploadContentDialog"
        ></UploadContentDialog>
      </v-dialog>
    </v-content>
  </v-app>
</template>

<script>
/* eslint no-fallthrough: "off" */
import { logout } from '@/utils/auth';
import UploadContentDialog from '@/components/Content/UploadContentDialog.vue';
import gql from 'graphql-tag';
import EventBus from '@/utils/EventBus';

const UPDATE_USER_DARK_THEME = gql`
mutation update_user_dark_theme($sub: String!, $dark_theme: Boolean!) {
  update_users_by_pk(
    pk_columns: { sub: $sub },
    _set: {
      dark_theme: $dark_theme
    }
  ) {
    dark_theme
  }
}
`;

export default {
  name: 'App',
  components: {
    UploadContentDialog,
  },
  created() {
    // Watch for darkTheme store changes
    this.$store.watch(
      (state) => state.darkTheme,
      (newValue) => {
        this.$vuetify.theme.dark = newValue;
      },
    );
  },
  computed: {
    camerasAllowed() {
      return true;
    },
    mobilesAllowed() {
      return true;
    },
    headsetsAllowed() {
      return true;
    },
    videosAllowed() {
      if (this.user && this.user.attributes && this.user.attributes['custom:ffmpeg'] === true) {
        return true;
      }
      return false;
    },
    photosAllowed() {
      return false;
    },
    timelapsesAllowed() {
      return false;
    },
    uploadAllowed() {
      if (this.user && this.user.attributes && this.user.attributes['custom:ffmpeg'] === true) {
        return true;
      }
      return false;
    },
    presentationsAllowed() {
      return false;
    },
    streamsAllowed() {
      return false;
    },
    meetingsAllowed() {
      return false;
    },
    videocallsAllowed() {
      if (this.user && this.user.attributes && this.user.attributes['custom:videocalls'] === true) {
        return true;
      }
      return false;
    },
    isUserLoggedIn() {
      return !!(this.user);
    },
    user() {
      return this.$store.state.user;
    },
    currentRouteName() {
      return this.$route.name;
    },
    appBarIcon1Src() {
      const { currentRouteName } = this;
      switch (currentRouteName) {
        case 'Home':
        case 'Cameras':
        case 'Mobiles':
        case 'Headsets':
          return this.$vuetify.theme.dark ? '/button_locations_dark.png' : '/button_locations.png';
        case 'Locations':
          return '/button_grid.png';
        case 'Device':
        case 'Geofence':
          // eslint-disable-next-line
          if ('Locations' === this.$store.state.cameFromView) {
            return this.$vuetify.theme.dark ? '/button_locations_dark.png' : '/button_locations.png';
          }
          return this.$vuetify.theme.dark ? '/button_geolapse_dark.png' : '/button_geolapse.png';
        case 'Geolapse':
          return this.$vuetify.theme.dark ? '/button_device_dark.png' : '/button_device.png';
        default:
          return '';
      }
    },
  },
  data: () => ({
    drawer: false,
    uploadContentDialog: false,
    userId: null,
    version: `0.${process.env.VUE_APP_GIT_COMMITS}`,
  }),
  mounted() {
    if (process.env.VUE_APP_BUGHERD === 'true') {
      const bugherdScript = document.createElement('script');
      bugherdScript.setAttribute('src', 'https://www.bugherd.com/sidebarv2.js?apikey=e1nfmfkk53xlxobtprxgfq');
      document.head.appendChild(bugherdScript);
    }
  },
  methods: {
    toggleDarkMode() {
      const { sub } = this.$store.state.user.attributes;
      const { dark } = this.$vuetify.theme;

      const variables = {
        sub,
        dark_theme: !dark,
      };

      this.$apollo.mutate({
        mutation: UPDATE_USER_DARK_THEME,
        variables,
        // eslint-disable-next-line
        update: (cache, { data: { update_users } }) => {
          // TODO error handling what if mutation doesn't work
        },
      });
    },
    navigateToContentView() {
      this.$router.push({ name: 'Content' });
    },
    navigateToVideoCallsView() {
      this.$router.push({ name: 'Videocalls' });
    },
    logout() {
      logout();
    },
    appBarIcon1Navigate() {
      const { currentRouteName } = this;
      let route = null;
      switch (currentRouteName) {
        case 'Home':
        case 'Cameras':
        case 'Mobiles':
        case 'Headsets':
          route = { name: 'Locations' };
          break;
        case 'Locations':
          route = { name: 'Cameras' };
          break;
        case 'Device':
        case 'Geofence':
          EventBus.$emit('leavingGeofence', null);
          // eslint-disable-next-line
          if ('Locations' === this.$store.state.cameFromView) {
            route = { name: 'Locations' };
          } else {
            route = { name: 'Geolapse' };
          }
          break;
        case 'Geolapse':
          route = { name: 'Device', params: { id: this.$store.state.currentDeviceId } };
          break;
        default:
          route = null;
      }
      if (route) {
        this.$router.push(route);
      }
    },
  },
};
</script>
<style scoped>
.bg-color {
  background-color: #f0f0f0;
}

.bg-color-dark {
  background-color: #38383d;
}

.drawer-font {
  font-size: 80%;
  color: #7d7d7d;
}
.content-title {
  cursor: pointer;
}
</style>
